import { FlyerTemplatePosition } from "../../../../../../../../features/flyer-template/types/flyer-template-position/flyer-template-position.interface";
import { useFlyerTemplateCanvas } from "../../../../../../../../features/flyer-template/hooks/use-flyer-template-canvas.hook";
import { FlyerDetailPagePreviewLayout } from "../flyer-detail-page-preview-layout/flyer-detail-page-preview-layout.component";
import { FlyerDetailPagePreviewPosition } from "../flyer-detail-page-preview-position/flyer-detail-page-preview-position.component";
import React from "react";
import { FlyerDetailPagePreviewProps } from "./flyer-detail-page-preview.props";
import { findPagePositionPreviewById } from "../../../../types/flyer-detail-page-preview/flyer-detail-page-preview.functions";

export const FlyerDetailPagePreview = (props: FlyerDetailPagePreviewProps) => {
  const canvas = useFlyerTemplateCanvas(props.template);
  const template = props.template;

  const onCreatePagePosition = (templatePosition: FlyerTemplatePosition) => () =>
    props.onCreatePagePosition(templatePosition.id);

  const isSelected = (position: FlyerTemplatePosition) => {
    if (!props.editPositionId) {
      return false;
    }
    const positionPreview = findPagePositionPreviewById(props.editPositionId, props.pagePreview);
    if (!positionPreview) {
      return false;
    }
    return position.id === positionPreview.templatePositionId;
  };

  if (!template || !canvas) {
    return null;
  }

  return (
    <FlyerDetailPagePreviewLayout
      rows={template.rows}
      columns={template.columns}
      width={canvas.width}
      height={canvas.height}
    >
      {template.positions.map((templatePosition, index) => (
        <FlyerDetailPagePreviewPosition
          flyerEndDatePassed={props.flyerEndDatePassed}
          key={index}
          templatePosition={templatePosition}
          pagePositions={props.pagePreview.positions}
          language={props.selectedLanguage}
          onCreatePagePosition={onCreatePagePosition(templatePosition)}
          onEditPagePosition={props.onEditPagePosition}
          active={isSelected(templatePosition)}
        />
      ))}
    </FlyerDetailPagePreviewLayout>
  );
};
